import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from './AppIcon';
import Button from './ui/Button';
import { useAuth } from '../contexts/AuthContext';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const { user, userProfile } = useAuth();

  const currentRole = user ? (userProfile?.role || 'authenticated') : 'anon';

  const navigationItems = [
    { path: '/homepage', label: 'Home' },
    { path: '/plumbing-services', label: 'Plumbing' },
    { path: '/electrical-services', label: 'Electrical' },
    { path: '/commercial-experience', label: 'Commercial' },
    { path: '/schedule-service', label: 'Schedule' }
  ];

  const isActivePath = (path) => location?.pathname === path;

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const handlePhoneClick = () => {
    window.location.href = 'tel:0827935785';
  };

  return (
    <>
      <header className="header">
        <div className="header-container">
          <Link to="/homepage" className="header-logo">
            <Icon name="Wrench" size={28} color="var(--color-primary)" />
            <span>meriodine</span>
          </Link>

          <nav className="header-nav">
            {navigationItems?.map((item) => (
              <Link
                key={item?.path}
                to={item?.path}
                className={`header-nav-link ${isActivePath(item?.path) ? 'active' : ''}`}
              >
                {item?.label}
              </Link>
            ))}
          </nav>

          <div className="header-actions">
            {currentRole !== 'anon' && (
              <span className="hidden lg:block" style={{ fontSize: 12, opacity: 0.75 }}>
                Role: {currentRole}
              </span>
            )}
            <button
              onClick={handlePhoneClick}
              className="header-phone emergency-cta"
              aria-label="Call emergency number"
            >
              <Icon name="Phone" size={20} />
              <span>082 793 5785</span>
            </button>

            {user ? (
              <Link 
                to={userProfile?.role === 'admin' ? '/admin/dashboard' : '/customer/dashboard'} 
                className="hidden lg:block"
              >
                <Button variant="default">Dashboard</Button>
              </Link>
            ) : (
              <Link to="/signin" className="hidden lg:block">
                <Button variant="default">Sign In</Button>
              </Link>
            )}

            <button
              onClick={toggleMobileMenu}
              className="header-mobile-toggle"
              aria-label="Toggle mobile menu"
            >
              <Icon name="Menu" size={24} />
            </button>
          </div>
        </div>
      </header>
      <div className={`mobile-menu ${!isMobileMenuOpen ? 'closed' : ''}`}>
        <div className="mobile-menu-header">
          <Link to="/homepage" className="header-logo" onClick={closeMobileMenu}>
            <Icon name="Wrench" size={28} color="var(--color-primary)" />
            <span>meriodine</span>
          </Link>
          <button
            onClick={closeMobileMenu}
            className="mobile-menu-close"
            aria-label="Close mobile menu"
          >
            <Icon name="X" size={24} />
          </button>
        </div>

        <nav className="mobile-menu-nav">
          {navigationItems?.map((item) => (
            <Link
              key={item?.path}
              to={item?.path}
              className={`mobile-menu-link ${isActivePath(item?.path) ? 'active' : ''}`}
              onClick={closeMobileMenu}
            >
              {item?.label}
            </Link>
          ))}
          <Link
            to="/schedule-service"
            className="mobile-menu-link"
            onClick={closeMobileMenu}
          >
            Schedule Service
          </Link>
          <Link
            to="/contact"
            className="mobile-menu-link"
            onClick={closeMobileMenu}
          >
            Contact
          </Link>
          <Link
            to="/client-success-stories"
            className="mobile-menu-link"
            onClick={closeMobileMenu}
          >
            Success Stories
          </Link>
        </nav>

        <button
          onClick={handlePhoneClick}
          className="mobile-menu-phone emergency-cta"
          aria-label="Call emergency number"
        >
          <Icon name="Phone" size={20} />
          <span>082 793 5785</span>
        </button>
      </div>
    </>
  );
};

export default Header;